import { OUTINGS } from '@somnhold/content';
import type { PlayerId } from '../types.ts';
import type { CampaignState, Ms, OutingKey, OutingTally } from './types.ts';

const tally = (t: OutingTally | undefined, now: Ms, won: boolean): OutingTally => {
  const out = t ?? { n: 0, won: 0, last: 0, lastWon: 0, with: {} };
  out.n++;
  out.last = now;
  if (won) {
    out.won++;
    out.lastWon = now;
  }
  return out;
};

/**
 * Notes an outing for the Salidas screen: each live hero's tally (and who went with them), the group's,
 * and the run itself among the last few. Ghosts that came along are not company.
 */
export const logOuting = (s: CampaignState, now: Ms, key: OutingKey, pids: PlayerId[], won: boolean, note?: number): void => {
  const party = [...new Set(pids)].filter((pid) => s.players.some((p) => p.id === pid)).sort();
  if (!party.length) return;
  const log = (s.outings ??= { by: {}, group: {}, recent: [] });
  log.group[key] = tally(log.group[key], now, won);
  for (const pid of party) {
    const mine = (log.by[pid] ??= {});
    const t = (mine[key] = tally(mine[key], now, won));
    for (const o of party) if (o !== pid) t.with[o] = (t.with[o] ?? 0) + 1;
  }
  log.recent.push({ key, at: now, pids: party, won, ...(note !== undefined ? { note } : {}) });
  if (log.recent.length > OUTINGS.recent) log.recent.splice(0, log.recent.length - OUTINGS.recent);
};
